import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useUser } from '@client/new/hooks/use-user';
import { useOnboardingViewModel } from './view-model/Onboarding.viewModel';
import { OnboardingView } from './view/Onboarding.view';
import { OnboardingLoader } from './view/components/OnboardingLoader';

export const OnboardingPage = () => {
  const { influencer } = useUser();

  const creatorPublishedAt = influencer?.publishedAt ?? null;

  const vm = useOnboardingViewModel(creatorPublishedAt);

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<OnboardingLoader />}
      renderer={(data) => <OnboardingView {...data} />}
    />
  );
};
